/* jshint undef: true, unused: true */

var notJquery = require('../not-jquery'),
    FoBuComponentFactory = require('./fobu-component-factory');

module.exports = function component (componentSettings, foBu) {

  var nJ               = notJquery,
      componentFactory = new FoBuComponentFactory(componentSettings, foBu),
      componentObject  = componentFactory.getComponentObject(),
      element          = componentObject.element,
      wrapper          = componentObject.wrapper,
      valueDisplay     = document.createElement('div');



  nJ.addClass(valueDisplay, [componentSettings.attributes.class, 'foBu__input-display-text']);
  valueDisplay.innerHTML = foBu.existingValues[componentSettings.attributes.name];
  wrapper.appendChild(valueDisplay);

  foBu.addAttributes(element, {'type' : 'hidden'});


  return {
    wrapper           : wrapper,
    finaliseComponent : componentFactory.finaliseComponent
  };
};
